// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__lLSv6","clickable":"style_clickable__JzQK4","spin":"style_spin__AfqWk","playButton":"style_playButton__9ciHQ"};